export var MAX_FILE_SIZE = 5.3e7;
export var ACCEPT_IMAGES = '.png, .jpg, .jpeg';
export var ACCEPT_MS = '.doc, .docx, .xls, .xlsx, .ppt, .pptx';
export var ACCEPT_DEFAULT = '.pdf, .epub, .txt, .mp4';
export var ACCEPT = [ACCEPT_DEFAULT, ACCEPT_IMAGES, ACCEPT_MS].join(', ');
export var UPLOAD_MAX_SIZE = 104857600;
export var INITIAL_OPTIONS = {
    maxFilesSize: 2e9,
    maxFilesSizeErrorText: 'Превышена максимальная сумма размера файлов - 2Гб',
};
export var UPLOAD_ATTACHMENT_ENDPOINT = '/api/upload/attachment/';
export var JWT_TOKEN_URL_STAGE = 'https://id-stage.samoletgroup.ru/oauth2/jwt/';
export var JWT_TOKEN_URL_PROD = 'https://id.samoletgroup.ru/oauth2/jwt/';
export var CLIENT_ID_STAGE = 'nXhZWgEnWP0JOGdyxGT1UktHxhrSGSOFc9wW4znw';
export var CLIENT_ID_PROD = 'fcdTuwlmPPMchLnffH4Ss6m1MChgonTuMoxJq6s3';
export var SIZE_LIMIT_ERROR_MESSAGE = 'Произошла ошибка при загрузке файла. Размер файла превышает допустимый лимит';
export var UNHANDLED_ERROR_MESSAGE = 'Произошла ошибка при загрузке файла.';
export var MIME_EXTENSIONS_MAP = {
    'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    msword: 'doc',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'vnd.ms-excel': 'xls',
    'vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'vnd.ms-powerpoint': 'ppt',
    plain: 'txt',
};
//# sourceMappingURL=const.js.map